import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

/**
 * Fetch a tool-produced artifact's body as text, for an inline preview. Mints the presigned URL
 * inside the query so it is never an expired cached one. Artifacts are immutable, so never stale.
 */
export function useArtifactText(
  threadId: string,
  toolUseId: string,
  artifactName: string,
): UseQueryResult<string, Error> {
  const { agentThreadService } = useDomainServices();

  return useQuery<string, Error>({
    queryKey: ["agentThreadArtifactText", threadId, toolUseId, artifactName],
    queryFn: async ({ signal }) => {
      const { url } = await agentThreadService.getArtifactUrl(
        threadId,
        toolUseId,
        artifactName,
        { abortSignal: signal },
      );
      const content = await agentThreadService.getArtifactContent(url, {
        abortSignal: signal,
      });
      return content.text();
    },
    staleTime: Infinity,
  });
}
